import React, { Component } from 'react';
import classes from 'component-classes';
import transform, { toTransformValue } from 'choerodon-ui/pro/lib/_util/transform';
import { transformZoomData } from 'choerodon-ui/shared/util';
import EventManager, { stopEvent } from '../_util/EventManager';
function cloneElement(element, props) {
    if (props.style && element.props.style) {
        props.style = { ...element.props.style, ...props.style };
    }
    if (props.className && element.props.className) {
        props.className = `${element.props.className} ${props.className}`;
    }
    return React.cloneElement(element, props);
}
export default class Resizable extends Component {
    constructor() {
        super(...arguments);
        this.handleMouseDown = (event) => {
            stopEvent(event);
            const { currentTarget } = event;
            const clientX = transformZoomData(event.clientX);
            const { resizeEvent = new EventManager() } = this;
            const clz = classes(currentTarget);
            this.resizeEvent = resizeEvent;
            clz.add('react-draggable-dragging');
            resizeEvent
                .setTarget(currentTarget.ownerDocument)
                .addEventListener('mousemove', (e) => {
                transform(toTransformValue({
                    translateX: `${e.clientX - clientX}px`,
                }), currentTarget.style);
            })
                .addEventListener('mouseup', (e) => {
                const { onResize } = this.props;
                if (onResize) {
                    const x = transformZoomData(e.clientX) - clientX;
                    const dragCallbackData = {
                        x,
                        y: 0,
                        lastX: x,
                        lastY: 0,
                        deltaX: 0,
                        deltaY: 0,
                        node: currentTarget,
                    };
                    onResize(event, dragCallbackData);
                }
                currentTarget.style.cssText = '';
                resizeEvent.clear();
                clz.remove('react-draggable-dragging');
            });
        };
        this.saveDraggable = (draggable) => {
            this.draggable = draggable;
        };
    }
    componentWillUnmount() {
        const { resizeEvent } = this;
        if (resizeEvent) {
            resizeEvent.clear();
            delete this.resizeEvent;
        }
    }
    render() {
        const { children, className } = this.props;
        const { props: { children: subchildren } } = children;
        return cloneElement(children, {
            className: className ? `${className} react-resizable` : 'react-resizable',
            children: [
                subchildren,
                React.createElement("span", { ref: this.saveDraggable, key: "resizableHandle", className: "column-resizable-handle", onMouseDown: this.handleMouseDown }),
            ],
        });
    }
}
